import { useMutation } from 'react-query'
import axios from 'axios'
import moment from 'moment'

const patchHotSwap = async body => {
    const response = await axios.patch(
        `${process.env.API_URL}/hotswaps/update-address/${body.hotswapId}`,
        body.data
    )
    return response.data
}

const useUpdateHotswap = () => {
    return useMutation(patchHotSwap, {})
}

export const mapDataForUpdate = data => {
    return {
        firstName: data.firstName,
        lastName: data.lastName,
        date: moment(data.date).format('YYYY-MM-DD'),
        time: data.time,
        company: data.company,
        streetAddress: data.streetAndNumber,
        streetNumber: 0,
        zipCode: data.zipCode,
        country: data.country,
        city: data.city,
        note: data.note
    }
}

export default useUpdateHotswap
